// services/orderApiService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIK_MEDIC_API_URL;
const TOKEN = process.env.REACT_APP_QWIK_MEDIC_TOKEN;
const GITHUB_FAST_URL =
  "https://raw.githubusercontent.com/ahasanhamza/QwikMedic-Medicine/main/medicineNewData.json";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const orderApiService = {
  // Get all orders
  getAllOrders: async () => {
    try {
      const response = await axiosInstance.get('order/');
      return response.data.reverse(); // Reverse to show latest first
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  },

  // Get single order
  getOrder: async (id) => {
    try {
      const response = await axiosInstance.get(`order/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching order:', error);
      throw error;
    }
  },

  // Update order - full update with all fields
  updateOrder: async (id, orderData) => {
    try {
      const response = await axiosInstance.patch(`order/${id}`, orderData);
      return response.data;
    } catch (error) {
      console.error('Error updating order:', error);
      throw error;
    }
  },

  // Update only order status
  updateOrderStatus: async (id, statusData) => {
    try {
      const response = await axiosInstance.patch(`order/${id}`, statusData);
      return response.data;
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  },

  // Delete order
  deleteOrder: async (id) => {
    try {
      await axiosInstance.delete(`order/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting order:', error);
      throw error;
    }
  },

  // Create new order (if needed)
  createOrder: async (orderData) => {
    try {
      const response = await axiosInstance.post('order', orderData);
      return response.data;
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },

  // Get medicine discount from company contacts
  getMedicineDiscount: async () => {
    try {
      const response = await axiosInstance.get('companyContacts/1');
      return response.data;
    } catch (error) {
      console.error('Error fetching medicine discount:', error);
      throw error;
    }
  },

  // Search medicines
  searchMedicines: async (query = '') => {
    try {
      // First try from medicineNewData endpoint
      let response;
      // try {
      //   response = await axiosInstance.get('medicineNewData/');
      // } catch (error) {
      //   // Fallback to product endpoint
      //   response = await axiosInstance.get('product/');
      // }

      try {
        const fastRes = await fetch(GITHUB_FAST_URL);
        response = await fastRes.json();

        // if (Array.isArray(fastData) && fastData.length > 0) {
        //   console.log("Loaded medicines from GitHub");
        //   medicines = fastData;
        // }
      } catch (error) {
        console.log("GitHub fetch failed, trying API...");
      }



      const medicines = response;

      if (!query) return medicines.slice(0, 50); // Return first 50 if no query

      const searchTerm = query.toLowerCase();
      return medicines.filter(medicine => {
        const productName = medicine.productname || medicine.medicinename || '';
        const brand = medicine.productbrand || medicine.companyname || '';
        const genericName = medicine.genericname || '';

        return (
          productName.toLowerCase().includes(searchTerm) ||
          brand.toLowerCase().includes(searchTerm) ||
          genericName.toLowerCase().includes(searchTerm)
        );
      }).slice(0, 20); // Limit results to 20
    } catch (error) {
      console.error('Error searching medicines:', error);
      throw error;
    }
  },
};